import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { InstanceAPIs, Instances } from '../../../constants';
import { IStateType } from '../../../store/models/root.interface';
import { closeSideBar, getParams } from '../../../store/sidebar';
import {
	requestObjects,
	updateObjects,
	changeSearchStr,
	clearFilters,
} from '../../../store/Objects';

import CallbackProfileCreate, {
	MapDispatchToPropsType,
	MapStateToPropsType,
} from '../organisms/CallbackProfileCreate';
import { requestObject } from '../../../store/Object';

const mapStateToProps = (state: IStateType) => {
	const params = getParams(state);
	return {
		params,
	};
};

const mapDispatchToProps = {
	closeFilterModal: () => closeSideBar(),
	createCallbackProfile: (data: any, cb: (res: any) => void) =>
		updateObjects(
			Instances.CallbackProfiles,
			'POST',
			data,
			undefined,
			undefined,
			undefined,
			undefined,
			undefined,
			cb,
			'',
			InstanceAPIs[Instances.CallbackProfiles].POST
		),
	onSearchTextChange: (searchString: string) =>
		changeSearchStr(Instances.CallbackProfiles, searchString),
	initializeAndLoadData: (
		filters?: Record<string, any>,
		searchTerm?: string
	) => requestObjects(Instances.CallbackProfiles, filters, { searchTerm }),
	getCallbackProfileData: (id: string, cb: (res: any) => void) =>
		updateObjects(
			Instances.getCallProfileById,
			'GET',
			undefined,
			{},
			undefined,
			undefined,
			undefined,
			undefined,
			cb,
			id
		),
	updateCallbackProfile: (id: string, data: any, cb: (res: any) => void) =>
		updateObjects(
			Instances.CallbackProfiles,
			'PUT',
			data,
			undefined,
			undefined,
			'profile_id',
			undefined,
			undefined,
			cb,
			id,
			InstanceAPIs[Instances.CallbackProfiles].PUT
		),
	clearFilters: () => clearFilters(Instances.CallbackProfiles, '', {}),
	getDynamicVar: (cb: (res: any) => void) =>
		requestObjects(
			Instances.CallbackDynamicVars,
			undefined,
			undefined,
			undefined,
			undefined,
			'',
			'',
			cb
		),
	testCallbackProfile: (data: any, cb: (res: any) => void) =>
		requestObject(
			Instances.Callback,
			undefined,
			{},
			'POST',
			true,
			true,
			data,
			cb
		),
};

export default connect<
	MapStateToPropsType,
	MapDispatchToPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(CallbackProfileCreate));
